/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2018
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'underscore',
	'./VisSelectionInfo'
], function(_, Class) {

	'use strict';
	var VisTooltipInfo = Class.extend({

		init: function() {
			VisTooltipInfo.inherited('init', this, arguments);

			this._aCustomSelections = [];
		},

		addCustomSelection: function(label, value) {
			this._aCustomSelections.push({
				name: label,
				value: value
			});
		},

		getCustomLabelSelections: function() {
			return _.filter(this._aCustomSelections, (selection) => {
				return 'name' in selection && selection.name;
			});
		},

		getCustomTitleSelections: function() {
			return _.filter(this._aCustomSelections, (selection) => {
				return !('name' in selection) || !selection.name;
			});
		}
	});

	return VisTooltipInfo;
});
